import React from "react";
import { BedDouble, Luggage, Landmark, Bus, Plane, Droplets, HandHeart, Info } from "lucide-react";

const ICONS = { hotel: BedDouble, luggage: Luggage, mosque: Landmark, bus: Bus, plane: Plane, water: Droplets, dua: HandHeart };

const Inline = ({ text }) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i} className="font-semibold text-[#0A192F]">{part.slice(2, -2)}</strong>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );

function parse(body) {
  const blocks = [];
  for (const raw of body.split("\n")) {
    const line = raw.trim();
    if (!line) continue;
    const last = blocks[blocks.length - 1];
    const h = line.match(/^##\s+(?:@(\w+)\s+)?(.*)$/);
    const ul = line.match(/^-\s+(.*)$/);
    const ol = line.match(/^\d+\.\s+(.*)$/);
    if (h) blocks.push({ type: "h", icon: h[1], text: h[2] });
    else if (ul) last?.type === "ul" ? last.items.push(ul[1]) : blocks.push({ type: "ul", items: [ul[1]] });
    else if (ol) last?.type === "ol" ? last.items.push(ol[1]) : blocks.push({ type: "ol", items: [ol[1]] });
    else blocks.push({ type: "p", text: line });
  }
  return blocks;
}

export const isRich = (body) => /^##\s|^-\s|\*\*/m.test(body || "");

export const AnnouncementBody = ({ body, testId }) => (
  <div className="mt-2 space-y-2 text-sm leading-relaxed text-slate-600" data-testid={testId}>
    {parse(body).map((b, i) => {
      if (b.type === "h") {
        const Icon = ICONS[b.icon] || Info;
        return (
          <h4 key={i} className="flex items-center gap-2 pt-3 font-display text-[15px] font-bold text-[#0A192F]">
            <Icon size={16} strokeWidth={1.75} className="shrink-0 text-[#D4AF37]" />
            {b.text}
          </h4>
        );
      }
      if (b.type === "ul")
        return (
          <ul key={i} className="space-y-1.5">
            {b.items.map((it, j) => (
              <li key={j} className="flex items-start gap-2.5">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#D4AF37]" />
                <span><Inline text={it} /></span>
              </li>
            ))}
          </ul>
        );
      if (b.type === "ol")
        return (
          <ol key={i} className="space-y-1.5">
            {b.items.map((it, j) => (
              <li key={j} className="flex items-start gap-2.5">
                <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-[#0A192F] text-[10px] font-bold text-[#E9CE7D]">{j + 1}</span>
                <span><Inline text={it} /></span>
              </li>
            ))}
          </ol>
        );
      return <p key={i}><Inline text={b.text} /></p>;
    })}
  </div>
);
